import { createAction } from "@ngrx/store";

export const setCompany = createAction("[Company View Page] Set Company");
